module.exports = __webpack_public_path__ + "static/media/transgender-alt.73b4bb2c.svg";